exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.PopupInputEmail_input-popup-email_-b6_ {\n  width: 250px;\n}\n@media (min-width: 768px) {\n  .PopupInputEmail_input-popup-email_-b6_ {\n    margin-right: 40px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"input-popup-email": "PopupInputEmail_input-popup-email_-b6_"
};